//PYMES Constants
import imgHogar from "containers/Hogar/assets/pymes-bread.svg";
import imgPYMES from "containers/Pymes/assets/pymes-bread.svg";
import MessageMia from "containers/Segurykids/MessageMia";
import React from "react";
import imgAPI from "../assets/img/mex/accidentesPersonales/imgbreadcrumAP.png";
import imgAUTO from "../assets/img/mex/auto/car-bread.png";
import imgTBTA from "../assets/img/mex/travelBta/imgBreadcrum.png";
import imgMarine from "../containers/MarineInland/assets/contratistasICo.png";
import * as PRODUCTOS_IMP from "./constants/PRODUCTOS";
import KIDS_TEENS from "../assets/img/mex/segukids/SeguKidsTeens.png";

const IMG_RCPA =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/Li%CC%81neasFinancieras_icono_sept_AIG-01.jpg";

const IMG_RCP =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/icono_nov_AIG_ResponsabilidadCivilProfesional1.png";
const IMG_CYBER =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/icono_nov_AIG_SeguroCyber2-breadcrumb.png";
const IMG_DO =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/iconoInternoDo.png";
const IMG_CASUALITY =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/img/casuality/contratistas_icono_AIG.png";
const IMG_CASUALITY_GENERALES =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/img/casuality/generales_icono.png";

export const IMG_BANNER_LOGIN_AGENTES =
  "https://aigmex-general.s3.us-west-2.amazonaws.com/aiggo/banner_sso_agentes.jpg";

const tituloPymes = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Pymes</span>
  </React.Fragment>
);
const tituloAPindividual = (
  <React.Fragment>
    <span>Accidentes </span>
    <span className="text-info">Personales</span>
  </React.Fragment>
);
const tituloAuto = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Auto</span>
  </React.Fragment>
);

const tituloRCP = (
  <React.Fragment>
    <span>RCP </span>
  </React.Fragment>
);
const tituloCYBER = (
  <React.Fragment>
    <span>CYBER </span>
  </React.Fragment>
);

const tituloDO = (
  <React.Fragment>
    <span>{"D&O"} </span>
  </React.Fragment>
);

const tituloCasuality = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Responsabilidad Civil para Contratistas</span>
  </React.Fragment>
);

const tituloCasualityGeneral = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Responsabilidad Civil General</span>
  </React.Fragment>
);

const tituloHogar = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Hogar</span>
  </React.Fragment>
);

const tituloLineasFinancieras = (
  <React.Fragment>
    <span>RCPA </span>
  </React.Fragment>
);

const tituloMarineContratistas = (
  <React.Fragment>
    <span>Seguro de </span>
    <span className="text-info">Equipo de Contratistas</span>
  </React.Fragment>
);

const messageForm = (
  <React.Fragment>
    <MessageMia
      textMessage="¡Hola!, soy Angeles y seré tu asesora. Me encantará brindarte información para asegurar a quienes más amas.
"
    ></MessageMia>
  </React.Fragment>
);

export const PRODUCTOS = PRODUCTOS_IMP.default;

const subtitleHogarDtc = "";

const combineTitles = (title, subtitle) => {
  return (
    <React.Fragment>
      {title}
      {subtitle}
    </React.Fragment>
  );
};
export const PASOS_BREADCRUMBS = {
  [PRODUCTOS.TRAVELBTA]: {
    breadCrumb: {
      title: "Cotización Travel Guard",
      subtitle: "Cotización",
    },

    pasos: [
      "1. Datos personales",
      "2. Elige el plan",
      "3. Opción de pago",
      "4. Confirma tu compra",
    ],
    breadCrumbPasos: {
      1: {
        title: "Cotiza tu seguro de viajes",
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgTBTA,
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
      },
      2: {
        title: "Cotiza tu seguro de viajes",
        subtitle: "Programa los días de los planes que necesites",
        pasosActivos: [1, 2],
        img: imgTBTA,
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
      },
      3: {
        title: "Cotiza tu seguro de viajes",
        subTitle: "Confirma la información seleccionada",
        pasosActivos: [1, 2, 3],
        img: imgTBTA,
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
            active: false,
          },
        ],
      },
      4: {
        title: "Cotiza tu seguro de viajes",
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgTBTA,
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
            active: true,
          },
        ],
      },
      5: {
        title: "Cotiza tu seguro de viajes",
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Contratante",
            active: true,
          },
        ],
        img: imgTBTA,
      },
      6: {
        title: "Cotiza tu seguro de viajes",
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Contratante",
            active: true,
          },
        ],
        img: imgTBTA,
      },
    },
  },
  [PRODUCTOS.APINDIVIDUAL]: {
    breadCrumb: {
      title: "Emisión Seguro Accidentes Personales",
      subtitle: "Emisión",
    },
    pasos: [
      "1. Datos Personales",
      "2. Elige el Plan",
      "3. Opción de pago",
      //'4. Completa la informacion del pago',
    ],

    pasosCotizacion: [
      {
        title: "1. Datos Personales",
      },
      {
        title: "2. Elige el Plan",
      },
      {
        title: "3. Opción de pago",
      },
      {
        title: "4. Contratante",
      },
      {
        title: "5. Confirma tu compra",
      },
    ],
    pasosEmision: [
      {
        title: "1. Asegurado",
      },
      {
        title: "2. Beneficiarios",
      },
    ],

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloAPindividual,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgAPI,
      },
      2: {
        title: tituloAPindividual,
        subtitle: "Te ofrecemos los siguientes planes para cuidar de tu salud",
        pasosActivos: [1, 2],
        img: imgAPI,
      },
      3: {
        title: tituloAPindividual,
        subtitle:
          "Estás muy cerca de obtener tu seguro de accidentes personales",
        pasosActivos: [1, 2, 3],
        img: imgAPI,
      },
      4: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4],
        img: imgAPI,
      },
      5: {
        title: tituloAPindividual,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgAPI,
      },
    },
    breadCrumbPasosEmision: {
      1: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        img: imgAPI,
      },
      2: {
        title: tituloAPindividual,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2],
        img: imgAPI,
      },
      3: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3],
        img: imgAPI,
      },
    },

    breadCrumbPasos: {
      1: {
        title: tituloAPindividual,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAPI,
      },
      2: {
        title: tituloAPindividual,
        subtitle: "Te ofrecemos los siguientes planes para cuidar de tu salud",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAPI,
      },
      3: {
        title: "Accidentes Personales",
        subtitle:
          "Estás muy cerca de obtener tu seguro de accidentes personales",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAPI,
      },
      4: {
        title: tituloAPindividual,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        pasos: [
          {
            title: "1. Datos personales",
            active: true,
          },
          {
            title: "2. Elige el plan",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
            active: true,
          },
        ],
        img: imgAPI,
      },

      5: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Contratante",
            active: true,
          },
          {
            title: "2. Asegurado",
          },
          // {
          //   title: '3. Beneficiarios',
          // },
        ],
        img: imgAPI,
      },
      6: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Contratante",
            active: true,
          },
          {
            title: "2. Asegurados",
            active: true,
          },
          // {
          //   title: '3. Beneficiarios',
          // },
        ],
        img: imgAPI,
      },
      7: {
        title: tituloAPindividual,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Contratante",
            active: true,
          },
          {
            title: "2. Asegurado",
            active: true,
          },
          {
            title: "3. Beneficiarios",
            active: true,
          },
        ],
        img: imgAPI,
      },
    },
  },
  [PRODUCTOS.AUTO]: {
    breadCrumb: {
      title: "Cotización Seguro de Auto",
      subtitle: "Cotización Seguro de Auto",
    },

    breadCrumbPasos: {
      1: {
        title: tituloAuto,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Datos del auto y personales",
            active: true,
          },
          {
            title: "2. Elige el paquete",
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
      },
      2: {
        title: tituloAuto,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Datos del auto y personales",
            active: true,
          },
          {
            title: "2. Elige el paquete",
            active: true,
          },
          {
            title: "3. Opción de pago",
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
      },
      3: {
        title: tituloAuto,
        subtitle: "Estás muy cerca de obtener tu seguro de auto",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Datos del auto y personales",
            active: true,
          },
          {
            title: "2. Elige el paquete",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
      },
      4: {
        title: tituloAuto,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        pasos: [
          {
            title: "1. Datos del auto y personales",
            active: true,
          },
          {
            title: "2. Elige el paquete",
            active: true,
          },
          {
            title: "3. Opción de pago",
            active: true,
          },
          {
            title: "4. Confirma tu compra",
            active: true,
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
      },

      5: {
        title: tituloAuto,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4],
        pasos: [
          {
            title: "1. Datos del vehículo",
            active: true,
          },
          {
            title: "2. Asegurado",
            active: true,
          },
          {
            title: "3. Conductor principal",
            active: true,
          },
          {
            title: "4. Contratante",
            active: true,
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      6: {
        title: tituloAuto,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Datos del vehículo",
            active: true,
          },
          {
            title: "2. Asegurado",
            active: true,
          },
          {
            title: "3. Conductor principal",
          },
          {
            title: "4. Contratante",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      7: {
        title: tituloAuto,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Datos del vehículo",
            active: true,
          },
          {
            title: "2. Asegurado",
          },
          {
            title: "3. Conductor principal",
          },
          {
            title: "4. Contratante",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      8: {
        title: tituloAuto,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Datos del vehículo",
            active: true,
          },
          {
            title: "2. Asegurado",
            active: true,
          },
          {
            title: "3. Conductor principal",
            active: true,
          },
          {
            title: "4. Contratante",
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      9: {
        title: tituloAuto,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Datos del vehículo",
            active: true,
          },
          {
            title: "2. Asegurado",
            active: true,
          },
          {
            title: "3. Conductor principal",
            active: true,
          },
          {
            title: "4. Contratante",
            active: true
          },
        ],
        img: imgAUTO,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
    },
  },
  [PRODUCTOS.pymesAbiertoInd]: {
    breadCrumb: {
      title: "Cotización Seguro de Pymes",
      subtitle: "Cotización Seguro de Pymes",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del asegurado",
      },
      {
        title: "2. Datos generales",
      },
      {
        title: "3. Ubicaciones",
      },
      {
        title: "4. Cotización",
      },
    ],
    pasosEmision: [
      {
        title: "1. Cliente",
      },
      {
        title: "2. Asegurado",
      },
      // {
      //   title: '3. Beneficiarios',
      // },
      {
        title: "3. Vigencia",
      },
      {
        title: "4. Pago",
      },
    ],

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloPymes,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      2: {
        title: tituloPymes,
        subtitle:
          "Sigamos avanzando en tu cotización, compártenos las características de tu negocio",
        pasosActivos: [1, 2],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      3: {
        title: tituloPymes,
        subtitle:
          "En este portal podrás cotizar y emitir negocios con valores de hasta 10 millones de dólares por ubicación dependiendo el giro",
        pasosActivos: [1, 2, 3],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      4: {
        title: tituloPymes,
        subtitle: "Estás a un paso de que tu negocio quede protegido",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
    },

    breadCrumbPasosEmision: {
      1: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        img: imgPYMES,
      },
      2: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        img: imgPYMES,
      },
      3: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3],
        img: imgPYMES,
      },
      4: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4],
        img: imgPYMES,
      },
    },
  },
  [PRODUCTOS.PRESUSCRITOS]: {
    breadCrumb: {
      title: "Cotización Seguro de Pymes",
      subtitle: "Cotización Seguro de Pymes",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del asegurado",
      },
      {
        title: "2. Zona de riesgo",
      },
      {
        title: "3. Planes",
      },
      {
        title: "4. Cotización",
      },
    ],
    pasosEmision: [
      {
        title: "1. Cliente",
      },
      {
        title: "2. Asegurado",
      },
      {
        title: "3. Pago",
      },
    ],

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloPymes,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      2: {
        title: tituloPymes,
        subtitle: "Selecciona una ubicación de riesgo",
        pasosActivos: [1, 2],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      3: {
        title: tituloPymes,
        subtitle: "Selecciona el plan que más se ajuste a tus necesidades",
        pasosActivos: [1, 2, 3],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
      4: {
        title: tituloPymes,
        subtitle: "Estás a un paso de que tu negocio quede protegido",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgPYMES,
        styleimg: "img-fluid img-breadcrumb",
      },
    },

    breadCrumbPasosEmision: {
      1: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1],
        img: imgPYMES,
      },
      2: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2],
        img: imgPYMES,
      },
      3: {
        title: tituloPymes,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3],
        img: imgPYMES,
      },
    },
  },
  [PRODUCTOS.HOGAR]: {
    breadCrumb: {
      title: "Cotización Seguro de Hogar",
      subtitle: "Cotización Seguro de Hogar",
    },

    pasosHogarFlex: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Información General",
      },
      {
        title: "3. Coberturas",
      },
      {
        title: "4. Opciones de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Pago",
      },
    ],

    pasosCotizacion: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Coberturas",
      },
      {
        title: "3. Opciones de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Coberturas",
      },
      {
        title: "3. Opciones de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloHogar,
        subtitle: combineTitles(
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
          subtitleHogarDtc
        ),
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle: combineTitles(
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
          subtitleHogarDtc
        ),
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",

        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      5: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",

        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",

        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: imgHogar,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloHogar,
        subtitle: combineTitles(
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
          subtitleHogarDtc
        ),
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle: combineTitles(
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
          subtitleHogarDtc
        ),
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",

        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",

        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
    },
    breadCrumbPasosCotizacionHogarFlex: {
      1: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",
        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      5: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: imgHogar,
      },
      7: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: imgHogar,
      },
      8: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: imgHogar,
      },
    },
  },
  [PRODUCTOS.HOGAR_FLEX]: {
    breadCrumb: {
      title: "Cotización Seguro de Hogar",
      subtitle: "Cotización Seguro de Hogar",
    },

    pasosHogarFlex: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Información General",
      },
      {
        title: "3. Coberturas",
      },
      {
        title: "4. Opciones de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Pago",
      },
    ],

    pasosCotizacion: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Coberturas",
      },
      {
        title: "3. Opciones de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del hogar y personales",
      },
      {
        title: "2. Información General",
      },
      {
        title: "3. Coberturas",
      },
      {
        title: "4. Opciones de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",
        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      5: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: imgHogar,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",
        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
    },
    breadCrumbPasosCotizacionHogarFlex: {
      1: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: imgHogar,
      },
      2: {
        title: tituloHogar,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: imgHogar,
      },
      3: {
        title: tituloHogar,
        subtitle: "Estás muy cerca de obtener tu seguro de hogar",
        pasosActivos: [1, 2, 3],
        img: imgHogar,
      },
      4: {
        title: tituloHogar,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: imgHogar,
      },
      5: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: imgHogar,
      },
      6: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: imgHogar,
      },
      7: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: imgHogar,
      },
      8: {
        title: tituloHogar,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: imgHogar,
      },
    },
  },
  [PRODUCTOS.LINEAS_FINANCIERAS]: {
    breadCrumb: {
      title: "Cotización Seguro de RCPA",
      subtitle: "Cotización Seguro de RCPA",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Vigencia",
      },
      {
        title: "7. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Vigencia",
      },
      {
        title: "7. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloLineasFinancieras,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_RCPA,
      },
      2: {
        title: tituloLineasFinancieras,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_RCPA,
      },
      3: {
        title: tituloLineasFinancieras,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_RCPA,
      },
      4: {
        title: tituloLineasFinancieras,
        subtitle: "Estás muy cerca de obtener tu seguro de RCPA",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_RCPA,
      },
      5: {
        title: tituloLineasFinancieras,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_RCPA,
      },
      6: {
        title: tituloLineasFinancieras,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_RCPA,
      },
      7: {
        title: tituloLineasFinancieras,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: IMG_RCPA,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloLineasFinancieras,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_RCPA,
      },
      2: {
        title: tituloLineasFinancieras,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_RCPA,
      },
      3: {
        title: tituloLineasFinancieras,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_RCPA,
      },
      4: {
        title: tituloLineasFinancieras,
        subtitle: "Estás muy cerca de obtener tu seguro de RCPA",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_RCPA,
      },
      5: {
        title: tituloLineasFinancieras,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_RCPA,
      },
      6: {
        title: tituloLineasFinancieras,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: IMG_RCPA,
      },
    },
  },
  [PRODUCTOS.CASUALITY]: {
    breadCrumb: {
      title: "Cotización Responsabilidad Civil para Contratistas",
      subtitle: "Cotización Responsabilidad Civil para Contratistas",
    },

    pasosCotizacion: [
      {
        title: "1. Perfil de negocio y datos personales",
      },
      {
        title: "2. Coberturas",
      },

      {
        title: "3. Opción de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Perfil de negocio y datos personales",
      },
      {
        title: "2. Coberturas",
      },
      {
        title: "3. Opción de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloCasuality,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CASUALITY,
      },
      2: {
        title: tituloCasuality,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: IMG_CASUALITY,
      },
      3: {
        title: tituloCasuality,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3],
        img: IMG_CASUALITY,
      },
      4: {
        title: tituloCasuality,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CASUALITY,
      },
      5: {
        title: tituloCasuality,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CASUALITY,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloCasuality,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CASUALITY,
      },
      2: {
        title: tituloCasuality,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: IMG_CASUALITY,
      },
      3: {
        title: tituloCasuality,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3],
        img: IMG_CASUALITY,
      },
      4: {
        title: tituloCasuality,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CASUALITY,
      },
      5: {
        title: tituloCasuality,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CASUALITY,
      },
    },
  },
  [PRODUCTOS.CASUALITY_GENERAL]: {
    breadCrumb: {
      title: "Cotización Responsabilidad Civil General",
      subtitle: "Cotización Responsabilidad Civil General",
    },

    pasosCotizacion: [
      {
        title: "1. Perfil de negocio y datos personales",
      },
      {
        title: "2. Coberturas",
      },

      {
        title: "3. Opción de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Vigencia",
      },
      {
        title: "6. Completa la información de tu compra",
      },
    ],

    pasosEmision: [
      {
        title: "1. Perfil de negocio y datos personales",
      },
      {
        title: "2. Coberturas",
      },
      {
        title: "3. Opción de pago",
      },
      {
        title: "4. Cliente",
      },
      {
        title: "5. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CASUALITY_GENERALES,
      },
      2: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: IMG_CASUALITY_GENERALES,
      },
      3: {
        title: tituloCasualityGeneral,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3],
        img: IMG_CASUALITY_GENERALES,
      },
      4: {
        title: tituloCasualityGeneral,
        subtitle:
          "Estás muy cerca de obtener tu seguro de: Responsabilidad Civil General",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CASUALITY_GENERALES,
      },
      5: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CASUALITY_GENERALES,
      },
      6: {
        title: tituloCasualityGeneral,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CASUALITY_GENERALES,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CASUALITY_GENERALES,
      },
      2: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        img: IMG_CASUALITY_GENERALES,
      },
      3: {
        title: tituloCasualityGeneral,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3],
        img: IMG_CASUALITY_GENERALES,
      },
      4: {
        title: tituloCasualityGeneral,
        subtitle:
          "Estás muy cerca de obtener tu seguro de: Responsabilidad Civil General",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CASUALITY_GENERALES,
      },
      5: {
        title: tituloCasualityGeneral,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CASUALITY_GENERALES,
      },
      6: {
        title: tituloCasualityGeneral,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_CASUALITY_GENERALES,
      },
    },
  },
  [PRODUCTOS.RCP]: {
    breadCrumb: {
      title: "Cotización Seguro de RCP",
      subtitle: "Cotización Seguro de RCP",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloRCP,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_RCP,
      },
      2: {
        title: tituloRCP,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_RCP,
      },
      3: {
        title: tituloRCP,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_RCP,
      },
      4: {
        title: tituloRCP,
        subtitle: "Estás muy cerca de obtener tu seguro de RCP",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_RCP,
      },
      5: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_RCP,
      },
      6: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_RCP,
      },
      7: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: IMG_RCP,
      },
      8: {
        title: tituloRCP,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_RCP,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloRCP,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_RCP,
      },
      2: {
        title: tituloRCP,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_RCP,
      },
      3: {
        title: tituloRCP,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_RCP,
      },
      4: {
        title: tituloRCP,
        subtitle: "Estás muy cerca de obtener tu seguro de RCP",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_RCP,
      },
      5: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_RCP,
      },
      6: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_RCP,
      },
      7: {
        title: tituloRCP,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 7],
        img: IMG_RCP,
      },
      8: {
        title: tituloRCP,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_RCP,
      },
    },
  },
  [PRODUCTOS.CYBER]: {
    breadCrumb: {
      title: "Cotización Seguro de Cyber",
      subtitle: "Cotización Seguro de Cyber",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloCYBER,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CYBER,
      },
      2: {
        title: tituloCYBER,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_CYBER,
      },
      3: {
        title: tituloCYBER,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_CYBER,
      },
      4: {
        title: tituloCYBER,
        subtitle: "Estás muy cerca de obtener tu seguro de Cyber",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CYBER,
      },
      5: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CYBER,
      },
      6: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_CYBER,
      },
      7: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: IMG_CYBER,
      },
      8: {
        title: tituloCYBER,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_CYBER,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloCYBER,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_CYBER,
      },
      2: {
        title: tituloCYBER,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_CYBER,
      },
      3: {
        title: tituloCYBER,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_CYBER,
      },
      4: {
        title: tituloCYBER,
        subtitle: "Estás muy cerca de obtener tu seguro de Cyber",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_CYBER,
      },
      5: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_CYBER,
      },
      6: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_CYBER,
      },
      7: {
        title: tituloCYBER,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 7],
        img: IMG_CYBER,
      },
      8: {
        title: tituloCYBER,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_CYBER,
      },
    },
  },
  [PRODUCTOS.DO]: {
    breadCrumb: {
      title: "Cotización Seguro de D&O",
      subtitle: "Cotización Seguro de D&O",
    },

    pasosCotizacion: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    pasosEmision: [
      {
        title: "1. Datos del seguro",
      },
      {
        title: "2. Declaraciones",
      },
      {
        title: "3. Elige tu plan",
      },
      {
        title: "4. Opción de pago",
      },
      {
        title: "5. Cliente",
      },
      {
        title: "6. Asegurado",
      },
      {
        title: "7. Vigencia",
      },
      {
        title: "8. Confirmación de pago",
      },
    ],

    breadCrumbPasosEmision: {
      1: {
        title: tituloDO,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_DO,
      },
      2: {
        title: tituloDO,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_DO,
      },
      3: {
        title: tituloDO,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_DO,
      },
      4: {
        title: tituloDO,
        subtitle: "Estás muy cerca de obtener tu seguro de D&O ",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_DO,
      },
      5: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_DO,
      },
      6: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_DO,
      },
      7: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        img: IMG_DO,
      },
      8: {
        title: tituloDO,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_DO,
      },
    },

    breadCrumbPasosCotizacion: {
      1: {
        title: tituloDO,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        img: IMG_DO,
      },
      2: {
        title: tituloDO,
        subtitle:
          "Por favor confirmar las siguientes declaraciones para continuar",
        pasosActivos: [1, 2],
        img: IMG_DO,
      },
      3: {
        title: tituloDO,
        subtitle:
          "Ahora elige el paquete que mejor se adapte a lo que necesitas",
        pasosActivos: [1, 2, 3],
        img: IMG_DO,
      },
      4: {
        title: tituloDO,
        subtitle: "Estás muy cerca de obtener tu seguro de D&O",
        pasosActivos: [1, 2, 3, 4],
        img: IMG_DO,
      },
      5: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5],
        img: IMG_DO,
      },
      6: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        img: IMG_DO,
      },
      7: {
        title: tituloDO,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 7],
        img: IMG_DO,
      },
      8: {
        title: tituloDO,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7, 8],
        img: IMG_DO,
      },
    },
  },

  [PRODUCTOS.MARINE_INLAND]: {
    breadCrumb: {
      title: "Cotización Equipo de Contratistas",
      subtitle: "Cotización Equipo de Contratistas",
    },

    breadCrumbPasos: {
      1: {
        title: tituloMarineContratistas,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
          },
          {
            title: "3. Opciónes de pago",
          },
          {
            title: "4. Datos  adicionales",
          },
          {
            title: "5. Cliente",
          },
          {
            title: "6. Vigencia",
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
      },
      2: {
        title: tituloMarineContratistas,
        subtitle:
          "Necesitamos saber esta breve información para ofrecerte una cotización personalizada",
        pasosActivos: [1, 2],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
          },
          {
            title: "4. Datos  adicionales",
          },
          {
            title: "5. Cliente",
          },
          {
            title: "6. Vigencia",
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
      },
      3: {
        title: tituloMarineContratistas,
        subtitle: "Completa la información de tu compra",
        pasosActivos: [1, 2, 3],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
          },
          {
            title: "4. Datos  adicionales",
          },
          {
            title: "5. Cliente",
          },
          {
            title: "6. Vigencia",
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
      },
      4: {
        title: tituloMarineContratistas,
        subtitle: "Estas muy cerca de obtener tu seguro de MEQP",
        pasosActivos: [1, 2, 3, 4],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
            active: true,
          },
          {
            title: "4. Datos  adicionales",
            active: true,
          },
          {
            title: "5. Cliente",
          },
          {
            title: "6. Vigencia",
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
      },

      5: {
        title: tituloMarineContratistas,
        subtitle: "Estas muy cerca de obtener tu seguro de MEQP",
        pasosActivos: [1, 2, 3, 4, 5],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
            active: true,
          },
          {
            title: "4. Datos  adicionales",
            active: true,
          },
          {
            title: "5. Cliente",
            active: true,
          },
          {
            title: "6. Vigencia",
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
      },
      6: {
        title: tituloMarineContratistas,
        subtitle: "Estas muy cerca de obtener tu seguro de MEQP",
        pasosActivos: [1, 2, 3, 4, 5, 6],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
            active: true,
          },
          {
            title: "4. Datos  adicionales",
            active: true,
          },
          {
            title: "5. Cliente",
            active: true,
          },
          {
            title: "6. Vigencia",
            active: true,
          },
          {
            title: "7. Confirmación de pago",
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      7: {
        title: tituloMarineContratistas,
        subtitle: "Es necesario llenar la siguiente información",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
            active: true,
          },
          {
            title: "4. Datos  adicionales",
            active: true,
          },
          {
            title: "5. Cliente",
            active: true,
          },
          {
            title: "6. Vigencia",
            active: true,
          },
          {
            title: "7. Confirmación de pago",
            active: true,
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
      8: {
        title: tituloMarineContratistas,
        subtitle: "",
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
        pasos: [
          {
            title: "1. Perfil de negocio y datos personales",
            active: true,
          },
          {
            title: "2. Maquinaria",
            active: true,
          },
          {
            title: "3. Opciónes de pago",
            active: true,
          },
          {
            title: "4. Datos  adicionales",
            active: true,
          },
          {
            title: "5. Cliente",
            active: true,
          },
          {
            title: "6. Vigencia",
            active: true,
          },
          {
            title: "7. Confirmación de pago",
            active: true,
          },
        ],
        img: imgMarine,
        styleimg: "img-fluid img-breadcrumb",
        breadCrumb: {
          title: "Emisión de Seguro de Auto",
          subtitle: "Emisión de Seguro de Auto",
        },
      },
    },
  },
  [PRODUCTOS.SEGUKIDS]: {
    breadCrumb: {
      title: "Cotización SeguKids & Teens",
      subtitle: "Cotización SeguKids & Teens",
    },

    pasosContratante: [
      {
        title: "1. Datos personales",
      },
      {
        title: "2. Planes",
      },
      {
        title: "3. Forma pago",
      },
      {
        title: "4. Pagador",
      },
      {
        title: "5. Contratante",
      },
      {
        title: "6. Asegurados",
      },
      {
        title: "7. Conf. pago",
      },
    ],
    breadCrumbPasosSegukids: {
      1: {
        title: KIDS_TEENS,
        pasosActivos: [1],
        subtitle: messageForm,
      },
      2: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2],
      },
      3: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2, 3],
      },

      4: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2, 3, 4],
      },
      5: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2, 3, 4, 5],
      },
      6: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2, 3, 4, 5, 6],
      },
      7: {
        title: KIDS_TEENS,
        pasosActivos: [1, 2, 3, 4, 5, 6, 7],
      },
    },
  },
};
